import Types from '../types';

export function onFileListModalChange(fileListModal) {
  return { type: Types.FILELISTMODAL_CHANGE, fileListModal: fileListModal };
}

export function onTokenIdChange(tokenId) {
  return { type: Types.TOKENID_CHANGE, tokenId: tokenId };
}

export function onHandleImgErrChange(handleImgErr) {
  return { type: Types.HANDLEIMGERR_CHANGE, handleImgErr: handleImgErr };
}

export function onUserActionChange(userAction) {
  return { type: Types.USERACTION_CHANGE, userAction: userAction };
}

export function onAuthorizationChange(authorization) {
  return { type: Types.AUTHORIZATION_CHANGE, authorization: authorization };
}

export function onPurchaseModalObjChange(purchaseModalObj) {
  return {
    type: Types.PURCHASEMODALOBJ_CHANGE,
    purchaseModalObj: purchaseModalObj,
  };
}

export function onProfileObjChange(profileObj) {
  return { type: Types.PROFILEOBJ_CHANGE, profileObj: profileObj };
}

export function onSubscriptionChange(subscription) {
  return { type: Types.SUBSCRIPTION_CHANGE, subscription: subscription };
}

export function onVideoEditorTimesChange(videoEditorTimes) {
  return {
    type: Types.VIDEOEDITORTIMES_CHANGE,
    videoEditorTimes: videoEditorTimes,
  };
}

export function onImageCutoutTimesChange(imageCutoutTimes) {
  return {
    type: Types.IMAGECUTOUTTIMES_CHANGE,
    imageCutoutTimes: imageCutoutTimes,
  };
}

export function openAdvertiseDialog(advertiseDialog) {
  return { type: Types.OPEN_ADVERTISE, advertiseDialog: advertiseDialog };
}

export function advertiseConfig(advertiseConfig) {
  return { type: Types.ADVERTISE_CONFIG, advertiseConfig: advertiseConfig };
}
export function downloadPercent(percent) {
  return { type: Types.DOWNLOAD_PERCENT, percent: percent };
}

export function hideLink(isHide) {
  return { type: Types.HIDE_LINK, isHide: isHide };
}

export function onPayBill(payBill) {
  return { type: Types.PAYBILL, payBill: payBill };
}

export function onPayTrigger(payTrigger) {
  return { type: Types.PATRIGTER, payTrigger: payTrigger };
}

export function onExceed2M(exceed2M) {
  return { type: Types.EXCEED2M, exceed2M: exceed2M };
}

export function onSaveSku(sku) {
  return { type: Types.SAVESKU, sku: sku };
}
export function onSaveSwitchOther(sku) {
  return { type: Types.SAVESWITCHOTHER, skSwitchOther: sku };
}

export function onSignUpModal(signUpModal) {
  return { type: Types.SIGNUPMODAL, signUpModal: signUpModal };
}

export const loginIn = (userInfo) => {
  return { type: Types.LOGININ, userInfo };
};

export const loginOut = (msg) => {
  return { type: Types.LOGINOUT, msg };
};

export const sendVerification = (emailToken) => {
  return { type: Types.SENDVERIFICATION, emailToken };
};

export const signUpEmail = (userInfo) => {
  return { type: Types.SIGNUPWIDTHEMAIL, userInfo };
};

export const saveEmail = (userEmail) => {
  return { type: Types.SAVEEMAIL, userEmail };
};
